@use 'sass:map';
@import '@helsenorge/designsystem-react/scss/breakpoints';

.chatcards-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 2.68rem;
  margin-top: 1rem;
  margin-bottom: 4.5rem;

  @media (max-width: map.get($grid-breakpoints, lg)) {
    flex-direction: row;
  }

  @media (max-width: map.get($grid-breakpoints, md)) {
    margin-bottom: 2.5rem;
  }

  &__tools {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
  }
}

.chatcards-text {
  color: #fff;
  font-family: Avenir, Montserrat, Poppins, serif;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 2.25rem;
  margin: 0.125rem 0 1.5rem;
  white-space: pre-line;
  vertical-align: bottom;

  @media (max-width: map.get($grid-breakpoints, md)) {
    font-size: 1rem;
    line-height: 1.3rem;
  }
}
